import { createAction } from '@wix/communities-blog-client-common';

export const SET_LAST_POST_SLUG = 'lastPostSlug/SET';

export const setLastPostSlug = createAction(SET_LAST_POST_SLUG);
